import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import { ordersClient } from "@core/clients";
import { REVIEW_ORDER_SET_QUERY_CACHE_EXPIRE_TIME_MS } from "../../config/constansts";
import { OrderReviewType } from "@core/types";

const useReviewSetOrderById = (orderNumber: string, options: UseQueryOptions<OrderReviewType | null> = {}) => {
  return useQuery<OrderReviewType | null>(
    ["review", orderNumber],
    async () => {
      const res = await ordersClient.getReviewSetOrderById(orderNumber);
      return res;
    },
    {
      cacheTime: REVIEW_ORDER_SET_QUERY_CACHE_EXPIRE_TIME_MS,
      staleTime: REVIEW_ORDER_SET_QUERY_CACHE_EXPIRE_TIME_MS,
      ...options,
    }
  );
};

export default useReviewSetOrderById;
